
export enum LoadUnloadIdentifierCd {
	CUSTOMER_LOADS_AND_OR_UNLOADS_OUR_TRAILERS = 'CustomerLoadsAndOrUnloadsOurTrailers',
	DSR_LOADS_OR_UNLOADS_OUR_TRAILERS = 'DSRLoadsOrUnloadsOurTrailers'}

